import { NavLink } from "react-router-dom";
import "./Sidebar.css";
import {
  LayoutDashboard,
  Users,
  Truck,
  Package,
  ShoppingCart,
  Warehouse,
  FileText,
  Receipt,
  Wallet,
  TrendingDown,
  ClipboardList,
  Megaphone,
  Settings,
  Trophy,
  LogOut,
  Calculator,
  Globe
} from "lucide-react";

import authService from "../services/authService";
import { useNavigate } from "react-router-dom";

function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    authService.logout();
    navigate("/login");
  };

  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  return (
    <div className={`sidebar ${isOpen ? 'mobile-open' : ''}`}>
      <div className="sidebar-top">
        <div className="logo-container">
          <div className="logo-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <h2>ERP System</h2>
            <p className="admin-pill">Admin Access</p>
          </div>
          <button className="mobile-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="divider"></div>

        <nav className="nav-links">
          <NavLink to="/" end onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
            <LayoutDashboard size={20} className="icon" /> Dashboard
          </NavLink>

          {authService.hasPermission('crm', 'viewCustomers') && (
            <NavLink to="/crm" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
              <Users size={20} className="icon" /> CRM (Customers)
            </NavLink>
          )}

          {authService.hasPermission('vendor', 'viewVendor') && (
            <NavLink to="/vendors" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
              <Truck size={20} className="icon" /> Vendors
            </NavLink>
          )}

          {authService.hasPermission('product', 'viewProduct') && (
            <NavLink to="/products" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
              <Package size={20} className="icon" /> Products
            </NavLink>
          )}

          {authService.hasPermission('purchase', 'viewPurchase') && (
            <NavLink to="/purchases" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
              <ShoppingCart size={20} className="icon" /> Purchases
            </NavLink>
          )}

          <NavLink to="/warehouse" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
            <Warehouse size={20} className="icon" /> Warehouse / Inventory
          </NavLink>

          {authService.hasPermission('sales', 'viewSalesOrder') && (
            <NavLink to="/sales-orders" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
              <FileText size={20} className="icon" /> Sales Orders
            </NavLink>
          )}

          {authService.hasPermission('invoice', 'viewInvoice') && (
            <NavLink to="/invoices" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
              <Receipt size={20} className="icon" /> Invoices
            </NavLink>
          )}

          {authService.hasPermission('payments', 'viewPayments') && (
            <NavLink to="/payments" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
              <Wallet size={20} className="icon" /> Payments
            </NavLink>
          )}

          {authService.hasPermission('expenses', 'viewExpenses') && (
            <NavLink to="/expenses" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
              <TrendingDown size={20} className="icon" /> Expenses
            </NavLink>
          )}

          {authService.hasPermission('reports', 'viewReports') && (
            <NavLink to="/reports" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
              <ClipboardList size={20} className="icon" /> Reports
            </NavLink>
          )}

          <NavLink to="/marketing" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
            <Megaphone size={20} className="icon" /> Marketing & Follow-up
          </NavLink>

          <NavLink to="/vat" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
            <Calculator size={20} className="icon" /> VAT Portal
          </NavLink>

          <NavLink to="/integrations" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
            <Globe size={20} className="icon" /> Website Integration
          </NavLink>

          {authService.hasPermission('administration', 'manageUser') && (
            <>
              <NavLink to="/users" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
                <Settings size={20} className="icon" /> User Roles & Settings
              </NavLink>
              <NavLink to="/team-performance" onClick={handleLinkClick} className={({ isActive }) => isActive ? "active" : ""}>
                <Trophy size={20} className="icon" /> Team Performance
              </NavLink>
            </>
          )}
        </nav>
      </div>

      <button onClick={handleLogout} className="logout-btn">
        <LogOut size={20} className="icon" /> Logout
      </button>
    </div>
  );
}


export default Sidebar;
